<template>
  <div>
    <MovieList :movies="dorms" v-if="dorms"/>
<!--     <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
    <div slot="no-more"></div>
    <div slot="no-results"></div>
    </infinite-loading> -->

<!--     <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
    <div slot="no-more"></div>
    <div slot="no-results"></div>
    </infinite-loading> -->
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>
</template>

<script>
import MovieList from '@/components/MovieList'
import FixedPopup from '@/components/FixedPopup'
import InfiniteLoading from 'vue-infinite-loading'
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  name: 'BranchGender',
  components: {
    MovieList,
    FixedPopup,
    InfiniteLoading
  },
/*   metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.pageTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.pageDescription },
        { vmid: 'keywords', name: 'keywords', content: this.pageKeywords }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.url }
      ]
    }
  }, */
  data () {
    return {
      dormGender: '',
      dormWeb: '',
      dormLogo: '',
      branchedDormTitle: '',        
      url: '',
      page: 2,
      dorms: [],
      errors: [],
      gender: '',
      typeID: null,
      popupDorms: null,
      emptyContent: {
        icon: 'icon-search',
        title: 'No Result!',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      },
    }
  },
  methods: {
/*     infiniteHandler ($state) {
      this.checkGender()
      let self = this
      axios
        .get(`/site/cities/dorms/${this.$route.params.city}?dorm_type=${self.typeID}&page=${this.page}`)
        .then(response => {
          if (response.data.data.data) {
            this.page += 1
            // this.$router.replace('Page=' + this.page, { silent: true })
            if (Array.isArray(self.dorms) && Array.isArray(response.data.data.data) !== true && Object.keys(response.data.data.data).length !== 0) {
              Object.keys(response.data.data.data).forEach(item => {
                self.dorms.push(response.data.data.data[item])
              })
              self.popupDorms = response.data.data.popups
              $state.loaded()
            } else {
              $state.complete()
            }
          }
        })
    }, */
    checkGender () {
      const type = this.$attrs.redirect ? this.$route.params.slug : this.$route.params.type
      if (type && type.includes('erkek')) {
        this.gender = 'Erkek'
        this.typeID = 1
      } else if (type && type.includes('kiz')) {
        this.gender = 'Kız'
        this.typeID = 2
      }
    },
  getDorms() {
    const id = window.localStorage.getItem('branchedDormId')
    var self = this
        // const url = self.$attrs.redirect ? `/site/dorm/detail/old/${dormID}` : `/site/dorm/detail/${this.$route.params.id}`
       const url = `/site/dorm/branches/${id}`
       axios.get(url)
         .then(response => {
           // this.isLoading = false
           // self.detail = response.data
           if(self.dormGender === 'erkek') {
             self.dorms = []
                response.data.branches.forEach(item => {
                    if(item.dorm_type_id === 1) {
                self.dorms.push(item)
                    }
              })            
           } 
           else if(self.dormGender === 'kiz') {
             self.dorms = []
                response.data.branches.forEach(item => {
                    if(item.dorm_type_id === 2) {
                self.dorms.push(item)
                    }
              })            
           } 
           
    })
  }
  },
  computed: {
    ...mapGetters(['cityDetails']),
    pageTitle () {
      let title = ''
      if (this.cityDetails) {
        if (this.typeID === 1) title = this.cityDetails.male_title
        else if (this.typeID === 2) title = this.cityDetails.female_title
      }
      return title
    },
    pageDescription () {
      let title = ''
      if (this.cityDetails) {
        if (this.typeID === 1) title = this.cityDetails.male_description
        else if (this.typeID === 2) title = this.cityDetails.female_description
      }
      return title
    },
    pageKeywords () {
      let title = ''
      if (this.cityDetails) {
        if (this.typeID === 1) title = this.cityDetails.male_keywords
        else if (this.typeID === 2) title = this.cityDetails.female_keywords
      }
      return title
    }
  },
  mounted () {
    // this.getDorms()
      this.dormGender = window.localStorage.getItem('dormGender')
      this.getDorms()    
  },
  watch: {
    $route () {
      // this.checkGender()
      
      this.url = window.location.origin + this.$route.fullPath
      this.dormGender = window.localStorage.getItem('dormGender')
      this.getDorms()
    }
  },
  created() {
    this.url = window.location.origin + this.$route.fullPath
    let branchedDormTitle = window.localStorage.getItem('branchedDormTitle')
    this.branchedDormTitle = branchedDormTitle.replace('Yurtları', '')
    this.dormLogo = window.localStorage.getItem('dormLogo')
    this.dormWeb = window.localStorage.getItem('dormWeb')    
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/components/city";
  @import "../../assets/scss/components/pagination-new";

  /*.info-card {*/
    /*height: auto !important;*/
  /*}*/

  .wrapper {
    padding-bottom: 170px;
  }

  .dorm-tab__header {
    margin-top: -90px;
  }

  .select__title {
    font-size: 17px !important;
  }
  .city-text p {
    color: #fff !important;
  }
</style>
